import { render, staticRenderFns } from "./CartTakeOutTable.vue?vue&type=template&id=1c215ce1&scoped=true"
import script from "./CartTakeOutTable.vue?vue&type=script&lang=js"
export * from "./CartTakeOutTable.vue?vue&type=script&lang=js"
import style0 from "./CartTakeOutTable.vue?vue&type=style&index=0&id=1c215ce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c215ce1",
  null
  
)

export default component.exports